import React from "react"
import classes from "./portfolio.module.scss"
import SectionTitle from "../../components/UI/sectionTitle/sectionTitle"
// import Img from "gatsby-image"
// import ALink from "../../components/UI/ALink/ALink"
import { Element } from "react-scroll"

// import { StaticQuery, graphql } from "gatsby"

const portfolio = () => {
  return (
    <Element name="portfolio">
      <div className={classes.Container}>
        <SectionTitle titleType="White">Portfolio</SectionTitle>
        <div className={classes.ProjectsContainer}>
          {/*  
          <StaticQuery
            query={graphql`
              query MyQuery {
                allWordpressPost(
                  filter: {
                    categories: { elemMatch: { name: { eq: "Portfolio" } } }
                  }
                ) {
                  edges {
                    node {
                      acf {
                        live_version_link
                        childwordpressacfpostphoto_ {
                          localFile {
                            childImageSharp {
                              fluid(maxWidth: 500) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                        }
                      }
                      content
                      title
                      wordpress_id
                    }
                  }
                }
              }
            `}
            render={data =>
              data.allWordpressPost.edges.map(({ node }) => (
                <React.Fragment key={node.wordpress_id}>
                   Adding width so that flexbox could work properly 
                  <div
                    className={classes.dataContainer}
                    key={node.wordpress_id}
                  >
                    
                    <ALink
                      href={node.acf.live_version_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                     
                    <Img
                      fluid={
                        node.acf.childwordpressacfpostphoto_.localFile
                          .childImageSharp.fluid
                      }
                    />
                     </ALink> 

                    <div
                      className={classes.Collumn1}
                      dangerouslySetInnerHTML={{ __html: node.content }}
                    ></div>
                  </div>
                </React.Fragment>
              ))
            }
          />
         */}
        </div>
      </div>
    </Element>
  )
}

export default portfolio
